import { Component, Inject, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';

import { MyFilterPipe } from './myfilter.pipe';

@Component({
    selector: 'dbm-list2',
    template: require('./dbm-list2.component.html'),
    styles: [require('./dbm-list2.component.scss')]
})
export class DbmList2Component implements OnInit, OnDestroy {
    @Input() public listTitle: any;
    @Input() public listAction: any;
    @Input() public listSearchPlaceholder: any;
    @Input() public listItemRoute: any;
    @Input() public listItemIcon: any;
    @Input() public isProject: boolean;
    @Input() public labelListCheckboxFilters: any;
    @Input() public useCheckboxes: any;
    @Input() public applyRemove: any;
    @Input() public property: any;
    @Input() public listItems: any;
    @Input() public listMenu: any;
    @Input() public listCheckboxFilters: any;
    @Input() public notShowFilter: any;
    @Input() public notShowHeader: any;
    @Input() public maxLengthChars: any;
    @Input() public hasPackageDisableNotifiction: any;
    @Input() public hasPackageTemporyNotifiction: any;
    @Input() public packageNoSelectedText: string;
    @Input() public aggregationList: any;
    @Input() public noFirstClick: any;
    @Input() public disableFinishRender: any;

    @Output() public onSearchKey = new EventEmitter<any>();
    @Output() public onPackageFilterChange = new EventEmitter<any>();
    @Output() public onActionClick = new EventEmitter();
    @Output() public onListItemClick = new EventEmitter<any>();
    @Output() public onListItemRemove = new EventEmitter<any>();

    public filter = '';
    public selectedIndex: number;
    public lastSelectedItem: any;
    public selectedPackageFilter: any;
    public finishedInitialisation = null;
    public clickedOnAction = false;

    private defferedInitialiationTimeout = null;
    private listItemsFiltered: any;
    private catIndex: number;

    constructor(
        private myFilterPipe: MyFilterPipe,
        @Inject('$scope') $scope: any,
        @Inject('$state') public $state: any) {
        this.maxLengthChars = this.maxLengthChars || '26';
        $scope.$watch(() => this.listItems, (newVal: any, oldVal: any) => {
            if (!this.isProject){
                this.selectedIndex = 0;
            }
            if ((newVal && oldVal) && newVal.length !== oldVal.length) {
                this.finishedInitialisation = null;
            }
            if (newVal && newVal.length > 0) {
                this.finishedInitialisation = true;
                if (this.defferedInitialiationTimeout) {
                    clearTimeout(this.defferedInitialiationTimeout);
                }
            } else if (!this.finishedInitialisation && newVal && newVal.length == 0) {
                clearTimeout(this.defferedInitialiationTimeout);
                this.defferedInitialiationTimeout = this.deferedInitialization(newVal);
            }
        });
    }

    public ngOnInit() {
        if (this.listCheckboxFilters) {
            this.selectedPackageFilter = this.listCheckboxFilters.filter((x: any) => x.selected);
        }
    }

    public ngOnDestroy() {
        clearTimeout(this.defferedInitialiationTimeout);
    }

    private deferedInitialization(listItems: any) {
        return setTimeout(() => {
            if (!this.finishedInitialisation && listItems.length === 0) {
                this.finishedInitialisation = false;
            }
        }, 150);
    }

    public _onSearchKey() {
        if (this.onSearchKey) {
            this.onSearchKey.emit({ data: this.filter });
        }
    }

    private isRendered = false;
    public onFinishRender(last: any, lastSelectedItem: any) {
        if (!last && lastSelectedItem && lastSelectedItem.isNew && this.clickedOnAction) {
            this.clickedOnAction = false;
            this.selectedIndex = 0;
        }
        if (last && !this.isRendered) { // TODO Delete ngInit
            this.isRendered = true;
            const disableFinishRenderValue = this.disableFinishRender && this.disableFinishRender();
            if (!disableFinishRenderValue) {
                if (!this.aggregationList) {
                    this.selectedIndex = 0;
                    if (!this.noFirstClick) {
                        this.onListItemClick.emit({ selectedItem: this.listItems[0], indexInList: 0 });
                    }
                } else {
                    if (this.filter) {
                        this.listItemsFiltered = this.myFilterPipe.transform(this.listItems, this.filter);
                    }
                    if (lastSelectedItem) {
                        let indexCategory = this.listItems.findIndex(ctg => ctg.value.findIndex(rule => rule.name === lastSelectedItem.name) != -1);
                        if (indexCategory === - 1) {
                            // after update lastSelectedItem has old name so search by catergory
                            indexCategory = this.listItems.findIndex((item: any) => item.name == lastSelectedItem.category.Value);
                        }
                        if (indexCategory >= 0) {
                            if (!this.listItems[indexCategory].isOpen) {
                                this.clickOnCategory(this.listItems, this.listItems[indexCategory], indexCategory, false);
                            }
                            const indexRule = this.listItems[indexCategory].value.findIndex(rule => rule.id == lastSelectedItem.id || rule.name == lastSelectedItem.name)
                            // add/edit
                            if (indexRule >= 0) {
                                this.selectedIndex = indexCategory + indexRule + 1;
                                // duplicate
                                if (lastSelectedItem.newDuplicateId) {
                                    const indexRuleForDuplicate = this.listItems[indexCategory].value.findIndex(rule => rule.id == lastSelectedItem.newDuplicateId);
                                    this.selectedIndex = indexCategory + indexRuleForDuplicate + 1;
                                    delete lastSelectedItem.newDuplicateId;
                                }
                            } else {
                                // delete case
                                this.selectedIndex = indexCategory + 1;
                            }
                            if (this.selectedIndex >= 0) {
                                this.lastSelectedItem = this.listItems[this.selectedIndex];
                                if (this.filter) {
                                    const item = this.listItems[this.selectedIndex];
                                    this.catIndex = this.listItemsFiltered.findIndex(t => t.name == item.category.Value);
                                    const relvantrule = this.listItemsFiltered[this.catIndex].value.filter(item => item.name.toLowerCase().includes(this.filter.toLowerCase()))
                                    this.selectedIndex = this.catIndex + relvantrule.findIndex(_item => _item.id == item.id || _item.name == item.name) + 1;
                                    this.onListItemClick.emit({ selectedItem: this.lastSelectedItem, indexInList: this.selectedIndex });
                                } else {
                                    this.onListItemClick.emit({ selectedItem: this.listItems[this.selectedIndex], indexInList: this.selectedIndex });
                                }
                            }
                        }
                    } else {
                        this.clickOnCategory(this.listItems, this.listItems[0], 0, undefined);
                        this.selectedIndex = 0;
                        this.lastSelectedItem = this.listItems[0];
                        this.onListItemClick.emit({ selectedItem: this.listItems[0], indexInList: 0 });
                        this.clickOnCategory(this.listItems, this.listItems[0], 0, undefined);
                    }
                }
            }
        }
    }

    public clickOnCategory(array: any, _categroy: any, $index: any, flagToClick: any) {
        if (this.filter) {
            this.listItemsFiltered = this.myFilterPipe.transform(this.listItems, this.filter);
        }
        if (!_categroy.category && !_categroy.isNew) {
            // this is categroy
            $index = array.findIndex(item => item.name == _categroy.name);
            if (_categroy.isOpen) {
                this.selectedIndex = $index;
                this.lastSelectedItem = this.listItems[this.selectedIndex];
                this.listItems = array.filter(item => (!item.category || item.category.Value != _categroy.name));
                if (flagToClick) {
                    this.onListItemClick.emit({ selectedItem: _categroy, indexInList: $index });
                }
            } else {
                // need to open
                this.listItems = [...array.slice(0, $index + 1), ..._categroy.value, ...array.slice($index + 1)];
                let position = 0;
                if (this.filter) {
                    position = _categroy.value.findIndex((item: any) => item.name.toLowerCase().includes(this.filter.toLowerCase()));
                }
                this.selectedIndex = $index + position + 1;
                this.lastSelectedItem = this.listItems[this.selectedIndex];
                if (flagToClick) {
                    if (this.filter) {
                        const item = this.listItems[this.selectedIndex];
                        if (item.category) {
                            this.selectedIndex = this.listItemsFiltered.findIndex((t: any) => t.name == item.category.Value) + 1;
                        }
                        this.onListItemClick.emit({ selectedItem: (!_categroy.category) ? item : _categroy, indexInList: (!_categroy.category) ? this.selectedIndex : $index });
                    } else {
                        this.onListItemClick.emit({ selectedItem: (!_categroy.category) ? this.listItems[this.selectedIndex] : _categroy, indexInList: (!_categroy.category) ? this.selectedIndex : $index });
                    }
                }
            }
            _categroy.isOpen = !_categroy.isOpen;
        } else {
            if (this.filter) {
                const indexInfull = array.findIndex(item => item.name == _categroy.name);
                this.selectedIndex = $index;
                this.lastSelectedItem = this.listItems[indexInfull];
                this.onListItemClick.emit({ selectedItem: this.listItems[indexInfull], indexInList: $index });
            } else {
                $index = array.findIndex((item: any) => item.name == _categroy.name);
                this.selectedIndex = $index;
                this.lastSelectedItem = this.listItems[this.selectedIndex];
                this.onListItemClick.emit({ selectedItem: this.listItems[$index], indexInList: $index });
            }
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dbm-components/dbm-list2/dbm-list2.component.ts